export enum OrderEnum {
  ASC = "ASC",
  DESC = "DESC"
}